import React from 'react';
import { Table, Glyphicon, Button } from 'react-bootstrap';

export default ({ permissions }) => (
  <div>
    <Table bordered responsive>
      <thead>
        <tr key="header-table">
          <th key="Location">{permissions.email}</th>
          <th key="LocationId">Action</th>
        </tr>
      </thead>
      <tbody>
        {permissions.actions.map((user) => (
          <tr key={user.action + user.uuid}>
            <td>{user.action}</td>
            <td>
              <div className="text-center">
                <Button
                  onClick={() => {
                    permissions.delete_action(user.uuid, user.action);
                  }}
                >
                  <Glyphicon glyph="remove-circle" />
                </Button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);
